<template>
    <v-card>
        <v-card-title>
            Your Contact Information
        </v-card-title>
        <v-card-text>
            <v-alert :color="infoColor" prominent text type="info">
                <div class="font-weight-bold">Purpose</div>
                To give a third party (parent/guardian/sibling/friend/other) the ability to access
                information or service on your behalf.
            </v-alert>
            <v-form ref="contactForm" v-model="valid" lazy-validation>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field v-model="cnField" disabled label="Name" :rules="nameRules" required>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field v-model="usernameField" counter="8"
                                hint="Please provide only the Western ID. Do not include @uwo.ca" disabled
                                label="Western Email" persistent-hint :rules="mailRules" suffix="@uwo.ca" required>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" class="pb-0">
                            <v-text-field v-model="address" label="Current Address" :rules="addressRules" required>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer>
            </v-spacer>
            <v-btn class="white--text" :color="successColor" :disabled="!valid" @click="setStep(2)">
                Next
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'release-of-information-contact',
    props: {
        address: {
            required: true
        },
        cn: {
            required: true
        },
        username: {
            required: true
        }
    },
    data() {
        return {
            // addressField: this.address,
            addressRules: [
                v => !!v || 'Current address is required',
                v => (v && v.length >= 2) || 'Please provide a valid current address',
            ],
            cnField: this.cn,
            mailRules: [
                v => !!v || 'Western email is required',
                v => (v && v.length >= 2 && v.length <= 8) || 'Western email must be valid',
            ],
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 2) || 'Please provide a valid name',
            ],
            usernameField: this.username,
            valid: true
        }
    },
    methods: {
        setStep(val) {
            if (this.$refs.contactForm.validate()) {
                this.$emit('setAddress', this.address);
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            }
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        successColor() {
            return '#1bc5bd';
        }
    }
}
</script>